module.exports = __webpack_public_path__ + "img/svg/mastercard.7bc1ee259fca1c9a32c3621604f854db.svg";